import * as React from 'react';
import { throttle } from '@cian/newbuilding-utils';

import { FixedBlock } from '../../components/FixedBlock';
import { STICKY_HEADER_HEIGHT } from '../../constants/elements';
import { getCurrentScrollOffset } from '../../utils/dom/getCurrentScrollOffset';
import { Header } from '../Header';

const HEADER_HIDE_ZONE = 370;

export const FixedHeader = () => {
  const [isHeaderFixed, setHeaderFixed] = React.useState(false);

  const fixHeader = () => {
    const yOffser = getCurrentScrollOffset();

    if (yOffser > HEADER_HIDE_ZONE) {
      setHeaderFixed(true);
    } else if (yOffser < HEADER_HIDE_ZONE) {
      setHeaderFixed(false);
    }
  };

  const onScrollHandler = throttle(100, fixHeader);

  React.useEffect(() => {
    fixHeader();
    window.addEventListener('scroll', onScrollHandler, false);

    return () => {
      window.removeEventListener('scroll', onScrollHandler, false);
    };
  }, []);

  return (
    <FixedBlock top={isHeaderFixed ? 0 : -STICKY_HEADER_HEIGHT}>
      <Header isFixed={isHeaderFixed} />
    </FixedBlock>
  );
};
